"use client"

import clsx from "clsx"
import { useState } from "react"
import { WishlistIcon } from "src/components/icons"
import { localizeText } from "src/localization/utils"
import { StorefrontBaseProduct } from "src/types/storefront"
import { toggleWishlist, useIsOnWishlist } from "./state"
import { wishlistText } from "./text"

export type WishlistToggleButtonProps = {
  product: StorefrontBaseProduct
}

export const WishlistToggleButton = ({ product }: WishlistToggleButtonProps) => {
  const isOnWishlist = useIsOnWishlist(product)
  const [clicked, setClicked] = useState(false)

  const T = localizeText(wishlistText)
  const label = isOnWishlist ? T.removeFromWishlist : T.addToWishlist

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => {
        setClicked(true)
        toggleWishlist(product)
      }}
      className={clsx(
        "group text-brand-primary relative -m-1 p-1 drop-shadow-sm transition-[color,transform] duration-150 ease-out hover:text-inherit hover:transition-transform",
        isOnWishlist && "scale-125",
        isOnWishlist && clicked && "animate-[wishlist-on_0.25s_ease-out]",
      )}
    >
      <WishlistIcon className={clsx("size-6", isOnWishlist && "fill-current")} />
    </button>
  )
}
